/** Vietnamese — the default locale. Every user-facing string in the app starts here. */
export const vi = {
  common: {
    appName: 'VideoGrab Pro',
    save: 'Lưu',
    saving: 'Đang lưu…',
    saved: 'Đã lưu',
    cancel: 'Huỷ',
    close: 'Đóng',
    confirm: 'Xác nhận',
    delete: 'Xoá',
    remove: 'Gỡ',
    edit: 'Sửa',
    rename: 'Đổi tên',
    duplicate: 'Nhân bản',
    open: 'Mở',
    back: 'Quay lại',
    next: 'Tiếp',
    previous: 'Trước',
    search: 'Tìm kiếm',
    filter: 'Lọc',
    sort: 'Sắp xếp',
    retry: 'Thử lại',
    refresh: 'Làm mới',
    loading: 'Đang tải…',
    download: 'Tải xuống',
    upload: 'Tải lên',
    copy: 'Chép',
    copied: 'Đã chép',
    select: 'Chọn',
    selectAll: 'Chọn tất cả',
    deselectAll: 'Bỏ chọn',
    selected_one: 'Đã chọn {{count}} mục',
    selected_other: 'Đã chọn {{count}} mục',
    all: 'Tất cả',
    none: 'Không có',
    yes: 'Có',
    no: 'Không',
    more: 'Thêm',
    less: 'Thu gọn',
    viewAll: 'Xem tất cả',
    loadMore: 'Tải thêm',
    actions: 'Thao tác',
    status: 'Trạng thái',
    date: 'Ngày',
    name: 'Tên',
    type: 'Loại',
    size: 'Dung lượng',
    duration: 'Thời lượng',
    platform: 'Nền tảng',
    author: 'Tác giả',
    credits: 'Credit',
    creditsCost: '− {{count}} credit',
    free: 'Miễn phí',
    unlimited: 'Không giới hạn',
    optional: 'không bắt buộc',
    required: 'bắt buộc',
    reportIssue: 'Báo lỗi',
    errorCode: 'Mã lỗi: {{code}}',
    justNow: 'vừa xong',
    minutesAgo: '{{count}} phút trước',
    hoursAgo: '{{count}} giờ trước',
    daysAgo: '{{count}} ngày trước',
    unknown: 'Không rõ',
  },

  nav: {
    groupWork: 'Làm việc',
    groupResults: 'Kết quả',
    groupAdmin: 'Quản trị',
    overview: 'Tổng quan',
    download: 'Tải về',
    batch: 'Hàng loạt',
    explorer: 'Khám phá',
    projects: 'Dự án',
    library: 'Thư viện',
    libraryDownloads: 'Đã tải',
    libraryExports: 'Đã xuất',
    activity: 'Hoạt động',
    workspaces: 'Workspace',
    adminUsers: 'Người dùng',
    adminIntegrations: 'Tích hợp',
    adminFeedback: 'Góp ý',
    account: 'Tài khoản',
    support: 'Hỗ trợ',
    locked: 'Chưa được bật',
    collapse: 'Thu gọn thanh bên',
    expand: 'Mở rộng thanh bên',
    skipToContent: 'Bỏ qua tới nội dung chính',
  },

  workspaces: {
    title: 'Workspace nội dung',
    subtitle: 'Chia VideoGrab thành nhiều mảng độc lập và nối từng mảng với đúng workspace SocialForge.',
    current: 'Workspace hiện tại',
    create: 'Tạo workspace',
    createTitle: 'Tạo workspace mới',
    createHint: 'Project, lịch sử tải, batch và thư viện của workspace này được tách riêng.',
    description: 'Mô tả',
    areas: 'Các mảng nội dung',
    areasHint: 'Đổi workspace để chuyển toàn bộ ngữ cảnh làm việc.',
    isolationHint: 'Mọi dữ liệu sản xuất trên màn hình hiện tại đều thuộc workspace này.',
    noDescription: 'Chưa có mô tả.',
    default: 'Mặc định',
    projectCount: '{{count}} dự án',
    downloadCount: '{{count}} lượt tải',
    batchCount: '{{count}} batch',
    socialforgeTitle: 'Kết nối SocialForge',
    socialforgeHint: 'Mỗi workspace dùng một producer key riêng; key được mã hoá và không gửi lại trình duyệt.',
    connected: 'Đã kết nối',
    notConnected: 'Chưa kết nối',
    baseUrl: 'URL nội bộ SocialForge',
    publicUrl: 'URL mở trên trình duyệt',
    apiKey: 'Producer API key',
    apiKeyHint: 'Tạo producer key có bộ quyền Publish trong SocialForge.',
    apiKeyReplaceHint: 'Để đổi cấu hình, nhập lại producer key. Key đang lưu không bao giờ được điền ngược ra đây.',
    connect: 'Kết nối',
    replaceConnection: 'Cập nhật kết nối',
    check: 'Kiểm tra',
    disconnect: 'Ngắt kết nối',
    connectionSaved: 'Đã lưu và xác minh kết nối SocialForge.',
    connectionOk: 'Kết nối tốt · {{count}} channel khả dụng.',
    disconnected: 'Đã ngắt kết nối SocialForge.',
    switchTo: 'Chuyển workspace',
    manage: 'Quản lý workspace',
    disconnectTitle: 'Ngắt kết nối SocialForge?',
    disconnectBody:
      'Workspace “{{workspace}}” sẽ không gửi được nội dung sang SocialForge cho tới khi bạn nhập lại producer key. Các bài đã bàn giao không bị ảnh hưởng.',
  },

  socialforge: {
    send: 'Gửi sang SocialForge',
    title: 'Bàn giao nội dung',
    subtitle: 'Gửi video tới các channel thuộc workspace {{workspace}}.',
    notConnected: 'Workspace này chưa nối SocialForge.',
    notConnectedHint: 'Mở cài đặt workspace và nhập producer key dành riêng cho mảng này.',
    openSettings: 'Mở cài đặt workspace',
    channel: 'Channel đích',
    noChannels: 'Không có channel đang hoạt động và do SocialForge quản lý',
    videoSource: 'Video bàn giao',
    sourceProject: 'Video nguồn của dự án',
    sourceExport: 'Bản xuất · {{date}}',
    caption: 'Nội dung bài đăng',
    confirmSend: 'Tải lên và tạo publication',
    sent: 'Đã bàn giao nội dung cho SocialForge.',
    history: 'Lịch sử bàn giao',
    openPublication: 'Mở bài đăng',
    reconcile: 'Đồng bộ',
    supplyShort: '{{pending}} bài chờ · tối thiểu {{floor}}',
    supplyOk: 'Kênh đang có {{pending}} bài chờ đăng, đủ ngưỡng.',
    supplyLow: 'Kênh chỉ còn {{pending}} bài chờ, thiếu {{short}} bài so với ngưỡng.',
    supplyRule: 'SocialForge đăng {{perDay}} bài mỗi ngày và cần luôn có ít nhất {{floor}} bài chờ.',
    warmingUp: 'Page mới nên đang đăng ít để làm quen.',
    timingNote: 'Không cần chọn giờ: SocialForge tự xếp giờ đăng theo lịch của workspace bên đó.',
  },

  datePicker: {
    anyTime: 'Mọi thời gian',
    today: 'Hôm nay',
    last7: '7 ngày qua',
    last30: '30 ngày qua',
    thisMonth: 'Tháng này',
    clear: 'Xoá lọc ngày',
    previousMonth: 'Tháng trước',
    nextMonth: 'Tháng sau',
    pickStart: 'Chọn ngày bắt đầu',
    pickEnd: 'Từ {{date}} — chọn ngày kết thúc',
    weekdays: 'T2,T3,T4,T5,T6,T7,CN',
  },

  player: {
    label: 'Trình phát video',
    play: 'Phát',
    pause: 'Tạm dừng',
    mute: 'Tắt tiếng',
    unmute: 'Bật tiếng',
    volume: 'Âm lượng',
    seek: 'Tua video',
    speed: 'Tốc độ phát',
    fullscreen: 'Toàn màn hình',
    exitFullscreen: 'Thoát toàn màn hình',
    error: 'Không phát được video này.',
  },

  colorPicker: {
    open: 'Mở bảng màu',
    saturationBrightness: 'Độ đậm và độ sáng',
    hue: 'Sắc màu',
    eyedropper: 'Lấy màu trên màn hình',
    presets: 'Màu gợi ý',
  },

  auth: {
    signIn: 'Đăng nhập',
    signOut: 'Đăng xuất',
    email: 'Email',
    password: 'Mật khẩu',
    currentPassword: 'Mật khẩu hiện tại',
    newPassword: 'Mật khẩu mới',
    confirmPassword: 'Nhập lại mật khẩu mới',
    signingIn: 'Đang đăng nhập…',
    welcomeBack: 'Đăng nhập để tiếp tục',
    subtitle: 'Tải video, biên tập phụ đề và xuất bản — trong một nơi.',
    forcedTitle: 'Đổi mật khẩu để tiếp tục',
    forcedDescription:
      'Tài khoản đang dùng mật khẩu mặc định. Hãy đặt mật khẩu riêng trước khi sử dụng.',
    changePassword: 'Đổi mật khẩu',
    passwordUpdated: 'Đã đổi mật khẩu. Các phiên đăng nhập khác đã được đăng xuất.',
    sessionExpiredTitle: 'Phiên đăng nhập đã hết hạn',
    sessionExpiredBody:
      'Đăng nhập lại để tiếp tục. Việc bạn đang làm vẫn được giữ nguyên.',
    reauthenticate: 'Đăng nhập lại',
    lockedUntil: 'Tài khoản tạm khoá. Thử lại sau {{time}}.',
    rules: {
      title: 'Mật khẩu cần:',
      length: 'ít nhất 8 ký tự',
      upper: 'một chữ in hoa',
      lower: 'một chữ thường',
      digit: 'một chữ số',
      notDefault: 'khác mật khẩu mặc định',
      match: 'hai ô khớp nhau',
    },
  },

  errors: {
    INVALID_CREDENTIALS: 'Email hoặc mật khẩu không đúng.',
    TOKEN_EXPIRED: 'Phiên đăng nhập đã hết hạn.',
    NOT_AUTHENTICATED: 'Bạn cần đăng nhập.',
    ACCOUNT_TEMPORARILY_LOCKED: 'Sai quá nhiều lần. Tài khoản tạm khoá 15 phút.',
    ACCOUNT_DISABLED: 'Tài khoản đã bị khoá. Liên hệ quản trị viên.',
    FORCE_CHANGE_PWD: 'Bạn cần đổi mật khẩu trước khi tiếp tục.',
    FORBIDDEN: 'Bạn không có quyền thực hiện việc này.',
    ADMIN_REQUIRED: 'Chỉ quản trị viên mới truy cập được.',
    API_KEY_SCOPE_DENIED: 'API key không dùng được cho chức năng này.',
    FEATURE_DISABLED: 'Tính năng này chưa được bật cho tài khoản của bạn.',
    FEATURE_LIMIT_REACHED: 'Đã đạt giới hạn sử dụng trong ngày của tính năng này.',
    CREDIT_LIMIT_REACHED: 'Không đủ credit cho thao tác này.',
    NOT_FOUND: 'Không tìm thấy nội dung.',
    EXPIRED: 'Nội dung đã hết hạn.',
    CONFLICT: 'Dữ liệu đã thay đổi ở nơi khác.',
    VALIDATION_ERROR: 'Dữ liệu không hợp lệ.',
    PAYLOAD_TOO_LARGE: 'Tệp quá lớn.',
    UNSUPPORTED_MEDIA: 'Định dạng tệp không được hỗ trợ.',
    UPSTREAM_ERROR: 'Dịch vụ bên ngoài đang lỗi. Thử lại sau.',
    NOT_CONFIGURED: 'Tính năng này chưa được cấu hình trên máy chủ.',
    INTERNAL_ERROR: 'Lỗi hệ thống. Vui lòng thử lại.',
    NETWORK_ERROR: 'Mất kết nối máy chủ.',
    TIMEOUT: 'Yêu cầu quá thời gian chờ.',
    genericTitle: 'Đã xảy ra lỗi',
    notFoundTitle: 'Không tìm thấy trang',
    notFoundBody: 'Đường dẫn này không tồn tại hoặc đã bị đổi.',
    forbiddenTitle: 'Không đủ quyền',
    forbiddenBody: 'Tài khoản của bạn không được phép xem trang này.',
    serverTitle: 'Hệ thống gặp sự cố',
    serverBody: 'Chúng tôi đã ghi nhận lỗi này. Thử tải lại trang.',
    goHome: 'Về Tổng quan',
  },

  states: {
    emptyTitle: 'Chưa có gì ở đây',
    noMatchTitle: 'Không có kết quả phù hợp',
    noMatchBody: 'Thử từ khoá khác hoặc nới khoảng ngày.',
    clearFilters: 'Xoá bộ lọc',
    errorRetry: 'Thử lại',
    offline: 'Mất kết nối mạng',
    offlineBody: 'Kiểm tra mạng rồi thử lại. Thay đổi chưa lưu vẫn được giữ.',
  },

  feature: {
    lockedTitle: '{{name}} chưa được bật',
    lockedBody:
      'Tính năng này không nằm trong quyền của tài khoản bạn. Gửi yêu cầu để quản trị viên bật giúp.',
    requestAccess: 'Yêu cầu quyền truy cập',
    requestPrefill:
      'Tôi muốn được bật tính năng "{{name}}" cho tài khoản {{email}}.',
  },

  credits: {
    title: 'Credit',
    balance: 'Số dư',
    remaining: '{{remaining}}/{{limit}}',
    usedToday: 'Đã dùng hôm nay',
    resetsAt: 'Làm mới lúc {{time}}',
    resetsDaily: 'Làm mới 00:00 hằng ngày (giờ VN)',
    dailyLimit: 'Hạn mức ngày',
    priceList: 'Bảng giá',
    ledger: 'Sổ giao dịch',
    usage14d: 'Mức dùng 14 ngày',
    noTransactions: 'Chưa có giao dịch nào',
    refund: 'Hoàn credit',
    insufficientTitle: 'Không đủ credit',
    insufficientBody:
      'Thao tác này cần {{cost}} credit nhưng bạn chỉ còn {{remaining}}. Credit làm mới lúc {{time}}.',
    confirmTitle: 'Xác nhận sử dụng credit',
    confirmBody: 'Thao tác: {{action}}',
    confirmCost: 'Chi phí: {{cost}} credit',
    confirmBalance: 'Số dư: {{before}} → {{after}}',
    confirmProceed: 'Tiếp tục',
    viewLedger: 'Xem sổ giao dịch',
    usageTotal: 'Tổng: {{count}} credit',
    usageEmpty: 'Chưa dùng credit nào trong 14 ngày qua',
    rateGroup: {
      download: 'Tải về & khám phá',
      edit: 'Biên tập',
    },
    rates: {
      download_douyin: 'Tải video Douyin',
      download_tiktok: 'Tải video TikTok',
      download_bilibili: 'Tải video Bilibili',
      download_image: 'Tải bài ảnh',
      download_default: 'Nền tảng khác',
      profile_explorer: 'Khám phá profile (mỗi 20 video)',
      edit_auto_caption: 'Tạo phụ đề tự động',
      edit_ocr_detect: 'Đọc chữ trên video (OCR)',
      edit_asr_transcribe: 'Nhận dạng giọng nói',
      edit_translate: 'Dịch phụ đề',
      edit_tts: 'Giọng đọc AI',
      edit_shorts_analyze: 'Gợi ý đoạn cắt',
      edit_export: 'Xuất video',
    },
  },

  jobs: {
    title: 'Công việc',
    tray: 'Khay công việc',
    running: 'Đang chạy',
    recent: 'Gần đây',
    none: 'Không có công việc nào đang chạy',
    status: {
      pending: 'Đang chờ',
      running: 'Đang xử lý',
      completed: 'Hoàn thành',
      failed: 'Lỗi',
      cancelled: 'Đã huỷ',
    },
    type: {
      download: 'Tải video',
      auto_caption: 'Tạo phụ đề tự động',
      ocr_detect: 'Nhận chữ trên video',
      ocr_batch: 'Nhận chữ trên video',
      asr_transcribe: 'Nhận giọng nói',
      translate: 'Dịch phụ đề',
      tts_batch: 'Tạo giọng đọc',
      shorts_analyze: 'Gợi ý đoạn cắt',
      export: 'Xuất video',
    },
    canLeave: 'Bạn có thể rời trang — công việc vẫn chạy tiếp.',
    mustStay: 'Giữ trang mở đến khi xong.',
    resultIn: 'Kết quả sẽ xuất hiện ở {{place}}.',
    refunded: 'Đã hoàn {{count}} credit',
    viewResult: 'Xem kết quả',
    openProject: 'Mở dự án',
    completedToast: 'Xong: {{title}}',
    failedToast: 'Lỗi: {{title}}',
    onYourPc: 'Trên máy bạn',
  },

  overview: {
    title: 'Tổng quan',
    greeting: 'Chào {{name}}',
    creditCard: 'Credit hôm nay',
    continueWorking: 'Tiếp tục làm việc',
    continueEmpty: 'Chưa có dự án nào đang mở',
    runningJobs: 'Đang chạy',
    recentResults: 'Kết quả gần đây',
    recentResultsEmpty: 'Chưa có kết quả xuất nào',
    quickStart: 'Bắt đầu nhanh',
    quickPaste: 'Dán link để tải',
    quickUpload: 'Tải video lên để sửa',
    quickExplore: 'Khám phá profile',
    quickBatch: 'Xử lý hàng loạt',
    expiringTitle: 'Sắp hết hạn',
    expiringBody_one: '{{count}} mục sẽ hết hạn trong 48 giờ tới.',
    expiringBody_other: '{{count}} mục sẽ hết hạn trong 48 giờ tới.',
    newUserTitle: 'Bắt đầu với VideoGrab Pro',
    newUserBody: 'Ba bước để có video thành phẩm đầu tiên.',
    step1: 'Dán link video hoặc tải video lên',
    step2: 'Tạo dự án và biên tập phụ đề',
    step3: 'Xuất và tải kết quả về máy',
  },

  download: {
    title: 'Tải về',
    subtitle: 'Dán tối đa {{max}} link. Mỗi lần tải tối đa {{maxBatch}} mục.',
    inputLabel: 'Link video',
    inputPlaceholder: 'Dán link Douyin, TikTok hoặc Bilibili — mỗi link một dòng',
    analyze: 'Phân tích',
    analyzing: 'Đang phân tích…',
    clear: 'Xoá hết',
    resultsTitle: 'Kết quả phân tích',
    alreadyDownloaded: 'Đã tải',
    keepWatermark: 'Giữ watermark',
    watermarkNote:
      'Video đã tải trước đó sẽ được dùng lại, kể cả khi tuỳ chọn watermark khác lần trước.',
    downloadSelected: 'Tải {{count}} mục',
    editSelected: 'Sửa {{count}} mục',
    maxSelection: 'Chỉ chọn được tối đa {{max}} mục mỗi lần tải.',
    syncWarning: 'Tải chạy trực tiếp — giữ trang mở đến khi xong.',
    summary: 'Đã tải {{ok}}/{{total}}',
    summaryFailed: '{{count}} lỗi',
    summarySkipped: '{{count}} bỏ qua do thiếu credit',
    cannotEditImage: 'Bài ảnh không chỉnh sửa được',
    imagePost: 'Bài ảnh',
    editSkippedImages_one: 'Bỏ qua {{count}} bài ảnh — chỉ video mới chỉnh sửa được',
    editSkippedImages_other: 'Bỏ qua {{count}} bài ảnh — chỉ video mới chỉnh sửa được',
    editImportFailed: 'Không đưa được video này vào trình chỉnh sửa',
    editImportPartial_one: '{{count}} video không đưa vào được',
    editImportPartial_other: '{{count}} video không đưa vào được',
    parseFailed: 'Không phân tích được link này',
    emptyTitle: 'Chưa có link nào',
    emptyBody: 'Dán link vào ô trên rồi bấm Phân tích.',
    preview: 'Xem trước',
    historyTitle: 'Lịch sử link',
    historyHint: 'Mọi link đã phân tích hoặc tải, mới nhất trước.',
    historySearch: 'Tìm theo link, tên hoặc tác giả',
    historyEmpty: 'Chưa có link nào trong lịch sử.',
    historyNoMatch: 'Không tìm thấy link nào khớp.',
    historyUse: 'Dùng lại',
    historyUsed: 'Đã đưa link vào ô dán',
    historyOpen: 'Mở link gốc',
    historyCopyHint: 'Bấm để copy link',
    linkCopied: 'Đã copy link',
    linkCopyFailed: 'Không copy được link',
    historyStatus: {
      parsed: 'Đã phân tích',
      completed: 'Đã tải',
      failed: 'Lỗi',
    },
  },

  projects: {
    title: 'Dự án',
    subtitle: 'Nơi bạn biên tập video.',
    create: 'Tạo dự án',
    createTitle: 'Tạo dự án mới',
    fromDownload: 'Từ tệp đã tải',
    fromDownloadHint: 'Chọn một video trong thư viện của bạn',
    fromUpload: 'Tải lên từ máy',
    fromUploadHint: 'MP4, MOV, M4V, WEBM, MKV — tối đa {{max}}MB',
    fromUrl: 'Từ link',
    fromUrlHint: 'Tải về và mở thẳng trong trình chỉnh sửa',
    dropzone: 'Kéo video vào đây hoặc bấm để chọn',
    uploading: 'Đang tải lên… {{percent}}%',
    openEditor: 'Mở trình chỉnh sửa',
    emptyTitle: 'Chưa có dự án nào',
    emptyBody: 'Tạo dự án từ một video đã tải, từ máy của bạn, hoặc từ một link.',
    searchPlaceholder: 'Tìm theo tên dự án',
    sortActivity: 'Hoạt động gần nhất',
    sortCreated: 'Mới tạo',
    sortName: 'Theo tên',
    deleteTitle: 'Xoá dự án?',
    deleteBody:
      'Dự án "{{name}}", tệp video và các kết quả xuất của nó sẽ bị xoá. Lịch sử công việc và credit vẫn được giữ.',
    renameTitle: 'Đổi tên dự án',
    duplicated: 'Đã tạo bản sao',
    extended: 'Đã gia hạn dự án',
    extend: 'Gia hạn',
    previewUnavailable: 'Không xem trước được video này',
    detailSource: 'Nguồn',
    detailFiles: 'Tệp của dự án',
    detailExports: 'Kết quả xuất',
    detailJobs: 'Lịch sử công việc',
    noExports: 'Chưa xuất lần nào',
    noAssets: 'Chưa có nhạc hoặc giọng đọc',
    noJobs: 'Chưa có công việc nào',
    expiredTitle: 'Dự án đã hết hạn',
    expiredBody: 'Tệp của dự án này đã được dọn khỏi máy chủ sau thời gian không dùng.',
    recreate: 'Tạo lại từ nguồn',
    sourceUpload: 'Tải lên',
    sourceDownload: 'Từ tệp đã tải',
    sourceLink: 'Từ link',
  },

  editor: {
    backToProject: 'Về dự án',
    untitled: 'Dự án chưa đặt tên',
    unsaved: 'Chưa lưu',
    savingNow: 'Đang lưu…',
    savedAt: 'Đã lưu {{time}}',
    saveFailed: 'Chưa lưu — thử lại sau {{seconds}}s',
    saveRetry: 'Lưu lại ngay',
    undo: 'Hoàn tác',
    redo: 'Làm lại',
    menu: 'Thêm',
    viewSrt: 'Xem phụ đề (.srt)',
    downloadSrt: 'Tải .srt',
    importSrt: 'Nhập .srt',
    shortcuts: 'Phím tắt',
    export: 'Xuất',
    conflictTitle: 'Dự án đã thay đổi ở nơi khác',
    conflictBody:
      'Một tab hoặc thiết bị khác đã lưu dự án này. Tải lại để lấy bản mới nhất, hoặc ghi đè bằng bản đang sửa.',
    conflictReload: 'Tải lại',
    conflictOverwrite: 'Ghi đè',
    leaveWarning: 'Có thay đổi chưa lưu. Rời trang bây giờ sẽ mất chúng.',
    tabs: {
      captions: 'Phụ đề',
      voice: 'Giọng đọc',
      music: 'Nhạc',
      cut: 'Cắt',
      export: 'Xuất',
    },
    timeline: {
      captions: 'Phụ đề',
      voice: 'Giọng đọc',
      music: 'Nhạc',
      cuts: 'Cắt',
      ruler: 'Thanh thời gian',
      snap: 'Hít vào mốc thời gian',
      hint: 'Ctrl+lăn: thu phóng · Shift+lăn: cuộn ngang',
      resize: 'Kéo để đổi chiều cao timeline',
      showCaptions: 'Hiện phụ đề trên khung xem',
      hideCaptions: 'Ẩn phụ đề trên khung xem',
      menu: {
        title: 'Thao tác với dòng phụ đề',
        edit: 'Chỉnh sửa nội dung',
        duplicate: 'Nhân bản',
        duplicateMoved: 'Các hàng đều kín ở thời điểm này nên bản sao được đặt vào chỗ trống gần nhất ({{time}})',
        split: 'Tách tại vị trí phát',
        mergeNext: 'Nối với dòng kế tiếp',
        moveUp: 'Chuyển lên hàng trên',
        moveDown: 'Chuyển xuống hàng dưới',
        autoLane: 'Tự động chọn hàng',
        startAtPlayhead: 'Đặt điểm đầu tại vị trí phát',
        endAtPlayhead: 'Đặt điểm cuối tại vị trí phát',
        copyText: 'Chép nội dung',
        copied: 'Đã chép nội dung',
        copyFailed: 'Không chép được nội dung',
      },
      zoomIn: 'Phóng to',
      zoomOut: 'Thu nhỏ',
      fit: 'Vừa khung',
    },
    canvas: {
      play: 'Phát',
      pause: 'Tạm dừng',
      mute: 'Tắt tiếng',
      unmute: 'Bật tiếng',
      fullscreen: 'Toàn màn hình',
      exitFullscreen: 'Thoát toàn màn hình',
      speed: 'Tốc độ',
      noVideo: 'Không tải được video của dự án',
    },
    captions: {
      autoTitle: 'Tạo phụ đề tự động',
      autoHint: 'Đọc chữ có sẵn trên video (hoặc nghe lời nói), dịch, và chèn thẳng vào video — chỉ một bước.',
      autoTranslateToggle: 'Dịch sang tiếng Việt',
      autoTranslateHint: 'Tắt để giữ nguyên chữ/lời gốc, không dịch.',
      autoReplaceToggle: 'Thay thế phụ đề hiện có',
      autoReplaceHint: 'Xoá các dòng đang có trước khi thêm dòng mới. Tắt để giữ và thêm vào.',
      autoDone: 'Đã tạo {{count}} dòng phụ đề',
      autoNone: 'Không tìm thấy chữ hay lời nói nào trên video này',
      autoStage: {
        read: 'Đang đọc video…',
        translate: 'Đang dịch…',
        insert: 'Đang chèn vào video…',
        done: 'Xong',
      },
      advancedTitle: 'Tuỳ chọn nâng cao',
      otherSourcesTitle: 'Cách khác để thêm phụ đề',
      sourceTitle: 'Lấy phụ đề từ',
      ocr: 'Chữ trên video (OCR)',
      ocrHint: 'Quét chữ đã in sẵn trong khung hình',
      asr: 'Giọng nói trong video',
      asrHint: 'Nghe và gõ lại lời thoại',
      manual: 'Thêm thủ công',
      importSrt: 'Nhập tệp .srt',
      roiTitle: 'Vùng quét',
      roiFull: 'Toàn khung hình',
      roiCustom: 'Chọn vùng trên khung xem',
      roiReset: 'Đặt lại toàn khung',
      interval: 'Tần suất quét',
      intervalHint: 'Khoảng cách giữa các lần đọc khung hình — nhỏ hơn thì chính xác hơn nhưng chậm hơn.',
      language: 'Ngôn ngữ',
      languageAuto: 'Tự nhận',
      candidatesTitle: 'Kết quả tìm được',
      candidatesHint:
        'Chọn các dòng muốn dùng. Phụ đề được **thêm vào** danh sách hiện có, không thay thế.',
      apply: 'Thêm {{count}} dòng',
      manualHint: 'Nhấn nút thêm dòng (dấu +) trên thanh công cụ của track Phụ đề, hoặc nhấn đúp vào chỗ trống trên track đó.',
      addAtPlayhead: 'Thêm dòng tại vị trí phát',
      textPlaceholder: 'Nhập nội dung phụ đề…',
      editTitle: 'Chỉnh sửa phụ đề',
      visibilityTitle: 'Hiển thị',
      visibilityToggle: 'Hiện phụ đề trên khung xem',
      visibilityHint: 'Ẩn tạm để xem video không bị che chữ; không ảnh hưởng đến video xuất.',
      translate: 'Dịch',
      translateTitle: 'Dịch lại phụ đề đã có',
      retranslateHint: 'Dùng khi muốn đổi ngôn ngữ, giọng điệu, hoặc dịch lại phụ đề đã thêm bằng cách khác (thủ công, nhập .srt). Việc tạo phụ đề tự động ở trên đã tự dịch, không cần làm lại bước này.',
      translateWarning:
        'Bản dịch sẽ **ghi đè** nội dung hiện tại và không hoàn tác được. Nội dung gốc vẫn được giữ để tải .srt.',
      targetLang: 'Dịch sang',
      tone: 'Giọng điệu',
      toneNatural: 'Tự nhiên',
      toneFormal: 'Trang trọng',
      toneCasual: 'Thân mật',
      toneLiteral: 'Sát nghĩa',
      contextNote: 'Ghi chú ngữ cảnh',
      contextHint: 'Ví dụ: video nấu ăn, xưng hô thân mật',
      styleTitle: 'Kiểu chữ',
      styleSelectedTarget: 'Đang chỉnh dòng: “{{text}}”. Đổi là áp dụng ngay.',
      styleDefaultTarget:
        'Chưa chọn dòng nào nên đây là kiểu mặc định cho dòng mới. Bấm vào một dòng trên timeline để đổi kiểu riêng cho dòng đó.',
      styleBody: 'Chữ thường',
      styleHeadline: 'Tiêu đề',
      styleHeadlineHint: 'Tiêu đề là chữ to, đậm, màu đỏ — dành cho dòng chữ lớn nhất trên video.',
      font: 'Phông chữ',
      textColor: 'Màu chữ',
      bgColor: 'Màu nền',
      autoFitNote: 'Cỡ chữ và vị trí được tính tự động để che vừa khít chữ gốc.',
      fontSize: 'Cỡ chữ',
      bold: 'Đậm',
      align: 'Canh lề',
      padding: 'Đệm',
      applyToAll: 'Áp dụng cho tất cả',
      original: 'Bản gốc',
      translated: 'Bản dịch',
    },
    voice: {
      title: 'Giọng đọc',
      speaker: 'Giọng',
      preview: 'Nghe thử',
      speed: 'Tốc độ',
      generate: 'Tạo giọng đọc',
      generateHint:
        'Mỗi câu bắt đầu đúng lúc phụ đề của nó hiện ra. Câu dài hơn thời gian phụ đề được đọc nhanh hơn cho vừa, và không bao giờ đè lên câu sau.',
      pick: 'Chọn giọng',
      groupVieneu: 'Giọng VieNeu',
      groupCapcut: 'Giọng CapCut (có lúc tạm ngưng)',
      done_one: 'Đã tạo giọng đọc cho {{count}} câu.',
      done_other: 'Đã tạo giọng đọc cho {{count}} câu.',
      spedUp_one: '{{count}} câu được đọc nhanh hơn cho vừa thời gian phụ đề.',
      spedUp_other: '{{count}} câu được đọc nhanh hơn cho vừa thời gian phụ đề.',
      overflow_one: '{{count}} câu vẫn dài hơn thời gian phụ đề, nên câu sau được lùi lại một chút.',
      overflow_other: '{{count}} câu vẫn dài hơn thời gian phụ đề, nên câu sau được lùi lại một chút.',
      cut_one: '{{count}} câu ở cuối bị cắt vì video đã hết.',
      cut_other: '{{count}} câu ở cuối bị cắt vì video đã hết.',
      skipped_one: 'Bỏ qua {{count}} phụ đề không có chữ để đọc.',
      skipped_other: 'Bỏ qua {{count}} phụ đề không có chữ để đọc.',
      notConfigured: 'Giọng đọc chưa được cấu hình trên máy chủ.',
      notConfiguredHint: 'Liên hệ quản trị viên để bật dịch vụ đọc văn bản.',
      needCaptions: 'Cần có phụ đề trước khi tạo giọng đọc.',
      untranslatedWarning:
        'Một số dòng chưa được dịch. Giọng đọc sẽ đọc đúng nội dung đang hiển thị.',
      current: 'Bản đang dùng',
      volume: 'Âm lượng giọng đọc',
      none: 'Chưa có giọng đọc',
    },
    music: {
      title: 'Nhạc nền',
      chooseHint: 'Chọn một bài trong thư viện nhạc của bạn.',
      manage: 'Quản lý thư viện nhạc',
      unuse: 'Không dùng nhạc trong dự án này',
      none: 'Thư viện chưa có bài nào',
      emptyHint: 'Tải nhạc lên một lần trong Tài khoản, mục Thư viện nhạc, rồi quay lại đây để chọn.',
      openLibrary: 'Mở thư viện nhạc',
      selected: 'Đang dùng',
      trim: 'Cắt nhạc',
      trimStart: 'Bắt đầu từ',
      trimEnd: 'Kết thúc ở',
      offset: 'Bắt đầu phát ở giây',
      musicVolume: 'Âm lượng nhạc',
      videoVolume: 'Âm lượng video',
      loop: 'Lặp lại nếu nhạc ngắn hơn video',
      muteOriginal: 'Tắt tiếng gốc của video',
      startPointTitle: 'Chọn điểm bắt đầu của nhạc',
      startPointHint: 'Video dài {{videoDuration}} — nhạc sẽ được cắt còn đúng {{videoDuration}}, tính từ điểm bạn chọn dưới đây.',
      startPointLabel: 'Bắt đầu tại',
      startPointPreview: 'Nghe thử',
    },
    cut: {
      title: 'Đoạn cắt',
      add: 'Thêm đoạn tại playhead',
      addHint: 'Hoặc dùng phím I và O để đặt điểm đầu và cuối.',
      none: 'Chưa có đoạn cắt nào — bản xuất sẽ dùng toàn bộ video.',
      aiTitle: 'Gợi ý bằng AI',
      aiHint: 'AI đọc phụ đề và đề xuất các đoạn đáng cắt.',
      aiTarget: 'Độ dài mong muốn',
      aiRun: 'Phân tích',
      aiNeedCaptions: 'Cần có phụ đề trước khi phân tích.',
      aiResults: 'Đoạn được đề xuất',
      aiScore: 'Điểm {{score}}',
      useCandidate: 'Dùng đoạn này',
      transition: 'Chuyển cảnh',
      markInAt: 'Điểm đầu đã đánh dấu: {{time}}',
      transitionNone: 'Cắt thẳng — không hiệu ứng',
      transitionFast: 'Nhanh (0,2 giây)',
      transitionMedium: 'Vừa (0,35 giây)',
      transitionSlow: 'Chậm (0,6 giây)',
      overlapError: 'Các đoạn không được chồng lên nhau.',
      tooShort: 'Đoạn phải dài ít nhất 1 giây.',
    },
    exportPanel: {
      title: 'Xuất video',
      summary: 'Bản xuất sẽ gồm',
      withCaptions_one: '{{count}} dòng phụ đề',
      withCaptions_other: '{{count}} dòng phụ đề',
      withVoice: 'giọng đọc',
      withMusic: 'nhạc nền',
      withClips_one: '{{count}} đoạn cắt',
      withClips_other: '{{count}} đoạn cắt',
      wholeVideo: 'toàn bộ video',
      nothingToExport: 'Chưa có gì để xuất — thêm phụ đề, âm thanh hoặc một đoạn cắt.',
      mustSaveFirst: 'Đang lưu thay đổi trước khi xuất…',
      start: 'Xuất video',
      started: 'Đã bắt đầu xuất. Bạn có thể rời trang.',
      history: 'Lần xuất trước',
    },
    shortcutsDialog: {
      title: 'Phím tắt',
      playPause: 'Phát / tạm dừng',
      frameStep: 'Lùi / tiến 1 khung',
      secondStep: 'Lùi / tiến 1 giây',
      markIn: 'Đặt điểm đầu đoạn cắt',
      markOut: 'Đặt điểm cuối đoạn cắt',
      undo: 'Hoàn tác',
      redo: 'Làm lại',
      save: 'Lưu ngay',
      fullscreen: 'Toàn màn hình',
      help: 'Mở bảng này',
    },
    mobile: {
      title: 'Chế độ gọn',
      notice:
        'Màn hình nhỏ dùng chế độ gọn: sửa chữ, chạy xử lý và xuất. Kéo hộp phụ đề và mép đoạn cắt cần màn hình lớn hơn.',
      needsDesktop: 'Thao tác này cần màn hình lớn hơn.',
    },
  },

  library: {
    searchPlaceholder: 'Tìm theo mô tả hoặc tác giả',
    downloadFailed: 'Tải không thành công',
    title: 'Thư viện',
    downloads: 'Đã tải',
    exports: 'Đã xuất',
    downloadsEmpty: 'Chưa tải video nào',
    downloadsEmptyBody: 'Dán một link ở trang Tải về để bắt đầu.',
    exportsEmpty: 'Chưa có kết quả xuất nào',
    exportsEmptyBody: 'Mở một dự án và bấm Xuất để tạo video thành phẩm.',
    saveToComputer: 'Lưu về máy',
    openOriginal: 'Mở link gốc',
    redownload: 'Tải lại',
    expired: 'Đã hết hạn',
    expiresIn: 'Còn {{time}}',
    reopenProject: 'Mở dự án',
    deleteExportTitle: 'Xoá kết quả xuất?',
    deleteExportBody: 'Tệp video sẽ bị xoá. Lịch sử credit vẫn được giữ.',
    fromProject: 'Từ dự án',
    projectDeleted: 'Dự án đã xoá',
  },

  activity: {
    title: 'Hoạt động',
    subtitle: 'Mọi việc bạn đã chạy, kể cả khi dự án đã bị xoá.',
    empty: 'Chưa có hoạt động nào',
    emptyBody: 'Tải một video hoặc chạy một việc trong trình chỉnh sửa.',
    filterStatus: 'Trạng thái',
    filterType: 'Loại việc',
    filterSource: 'Nguồn',
    sourceEdit: 'Biên tập',
    sourceDownload: 'Tải về',
    creditsSpent: '{{count}} credit',
    noCredits: 'Miễn phí',
    updatedAt: 'Cập nhật lúc',
  },

  explorer: {
    title: 'Khám phá',
    subtitle: 'Tìm profile trên Douyin, TikTok và Bilibili.',
    inputLabel: 'Link profile hoặc UID',
    inputPlaceholder: 'Dán link profile, hoặc @handle, hoặc UID',
    find: 'Tìm',
    detected: 'Nhận diện: {{platform}}',
    notDetected: 'Không nhận ra nền tảng từ nội dung này.',
    tabPosts: 'Bài đăng',
    tabLiked: 'Đã thích (của tôi)',
    likedHint:
      'Đây là các video bạn đã thích trong ứng dụng này, lọc theo tác giả — không phải danh sách thích của họ.',
    loadMoreCost: 'Tải thêm (− {{cost}} credit)',
    truncatedWarning:
      'Chỉ tải được {{got}}/{{asked}} mục vì không đủ credit cho cả trang.',
    postsEmpty: 'Profile này chưa có bài đăng nào tải được.',
    saveProfile: 'Lưu profile',
    saved: 'Đã lưu',
    savedProfiles: 'Profile đã lưu',
    likedVideos: 'Video đã thích',
    likedSubtitle: 'Video bạn đã thả tim, gom lại từ mọi profile.',
    newFolder: 'Thư mục mới',
    folderName: 'Tên thư mục',
    rootFolder: 'Tất cả',
    maxDepth: 'Chỉ lồng được tối đa 3 tầng thư mục.',
    unsaveTitle: 'Bỏ lưu profile?',
    unsaveBody: '"{{name}}" sẽ bị gỡ khỏi thư viện profile của bạn.',
    savedEmpty: 'Chưa lưu profile nào',
    savedEmptyBody: 'Mở một profile và bấm Lưu để thêm vào đây.',
    likedEmpty: 'Chưa thích video nào',
    move: 'Di chuyển',
    copy: 'Sao chép',
    followers: 'Người theo dõi',
    following: 'Đang theo dõi',
    videos: 'Video',
    likes: 'Lượt thích',
    navSearch: 'Tìm profile',
    platform: 'Nền tảng',
    library: 'Thư viện profile',
    folderSummary: '{{folders}} thư mục, {{profiles}} profile',
    folderMeta: '{{profiles}} profile, {{folders}} thư mục',
    folderKind: 'Thư mục',
    dragHint: 'Kéo profile hoặc thư mục thả vào một thư mục để chuyển. Giữ Ctrl khi thả profile để sao chép.',
    sectionFolders: 'Thư mục',
    columnKind: 'Loại',
    columnUpdated: 'Cập nhật',
    sectionProfiles: 'Profile',
    followersShort: '{{value}} người theo dõi',
    videosShort: '{{value}} video',
    pathMore: 'Các thư mục ở giữa',
    moveFolderTitle: 'Chuyển thư mục "{{name}}" tới',
    folderMoved: 'Đã chuyển thư mục "{{name}}" vào {{folder}}',
    dropHere: 'Thả vào đây',
    moveTo: 'Chuyển tới…',
    copyTo: 'Sao chép tới…',
    removeHere: 'Gỡ khỏi thư mục này',
    unsave: 'Bỏ lưu',
    renameFolder: 'Đổi tên thư mục',
    deleteFolder: 'Xoá thư mục',
    deleteFolderTitle: 'Xoá thư mục "{{name}}"?',
    deleteFolderBody:
      'Profile và thư mục con bên trong được chuyển ra {{parent}}. Không profile nào bị bỏ lưu.',
    folderDeleted: 'Đã xoá thư mục. {{profiles}} profile và {{folders}} thư mục được chuyển ra ngoài.',
    folderRenamed: 'Đã đổi tên thư mục',
    folderCreated: 'Đã tạo thư mục "{{name}}"',
    moved: 'Đã chuyển "{{name}}" vào {{folder}}',
    copied: 'Đã sao chép "{{name}}" vào {{folder}}',
    alreadyThere: '"{{name}}" đã ở trong {{folder}}',
    removedHere: 'Đã gỡ "{{name}}" khỏi {{folder}}',
    removeLastTitle: 'Bỏ lưu "{{name}}"?',
    removeLastBody: 'Đây là nơi duy nhất lưu profile này. Gỡ ra là bỏ lưu hẳn.',
    folderEmpty: 'Thư mục này chưa có gì',
    folderEmptyBody: 'Kéo profile vào đây, hoặc mở một profile và chọn Lưu vào thư mục này.',
    folderNotFound: 'Không tìm thấy thư mục này',
    folderNotFoundBody: 'Có thể thư mục đã bị xoá.',
    searchSaved: 'Tìm profile hoặc thư mục',
    searchEverywhere: 'Kết quả trong toàn bộ thư viện',
    searchNothing: 'Không có profile hay thư mục nào khớp "{{term}}".',
    inFolder: 'Trong {{path}}',
    pickMoveTitle: 'Chuyển "{{name}}" tới',
    pickCopyTitle: 'Sao chép "{{name}}" tới',
    pickSaveTitle: 'Lưu "{{name}}" vào',
    pickHere: 'Đang ở đây',
    pickNewFolder: 'Thư mục mới trong mục đang chọn',
    pickCreate: 'Tạo',
    pickTooDeep: 'Mục đang chọn đã ở tầng thứ 3, không tạo thêm thư mục con được.',
    saveTo: 'Lưu vào thư mục',
    savedInLabel: 'Đã lưu trong',
    saveElsewhere: 'Lưu thêm vào thư mục khác…',
    savedTo: 'Đã lưu vào {{path}}',
    backTo: 'Quay lại {{name}}',
    openProfile: 'Mở profile',
    videosSummary: '{{total}} video, {{detected}} đã detect',
    selectUndetected: 'Chọn video chưa detect',
    nothingToSelect: 'Mọi video trên trang đã được detect hoặc đã chọn.',
  },

  batch: {
    title: 'Xử lý hàng loạt',
    subtitle:
      'Dán nhiều link một lúc. Hệ thống tải lần lượt từng video, đọc phụ đề, dịch và chèn sẵn vào dự án. Đóng trang hay tắt app vẫn chạy tiếp.',
    linksLabel: 'Link video',
    linksPlaceholder: 'Mỗi dòng một link Douyin, TikTok hoặc Bilibili. Dán nguyên đoạn chia sẻ cũng được.',
    linksHint: 'Tối đa 500 video mỗi đợt.',
    validLinks_one: '{{count}} link dùng được',
    validLinks_other: '{{count}} link dùng được',
    duplicates_one: '{{count}} link trùng',
    duplicates_other: '{{count}} link trùng',
    unsupported_one: '{{count}} link không hỗ trợ',
    unsupported_other: '{{count}} link không hỗ trợ',
    tooMany: 'Mỗi đợt tối đa {{max}} video. Hãy chia thành nhiều đợt.',
    extract_one: 'Trích xuất phụ đề ({{count}})',
    extract_other: 'Trích xuất phụ đề ({{count}})',
    recent: 'Các đợt gần đây',
    noRuns: 'Chưa có đợt nào',
    noRunsBody: 'Dán link ở trên rồi bấm Trích xuất phụ đề để bắt đầu.',
    status: 'Trạng thái',
    progress: 'Tiến độ',
    failedShort: 'Lỗi',
    createdAt: 'Tạo lúc',
    progressText: 'Đã xử lý {{done}}/{{total}} video',
    remaining: 'Còn khoảng {{time}}',
    setupTitle_one: 'Trích xuất phụ đề cho {{count}} video',
    setupTitle_other: 'Trích xuất phụ đề cho {{count}} video',
    setupBody: 'Chọn cách đọc phụ đề cho từng video. Các video được xử lý lần lượt, kết quả chèn thẳng vào dự án.',
    name: 'Tên đợt',
    namePlaceholder: 'Ví dụ: Kênh chạy bộ tháng 10',
    translate: 'Dịch sang tiếng Việt',
    readAll: 'Đọc phụ đề từ',
    readOne: 'Cách đọc phụ đề của video {{index}}',
    atMost: 'Tối đa',
    start_one: 'Bắt đầu ({{count}} video)',
    start_other: 'Bắt đầu ({{count}} video)',
    mode: {
      auto: 'Tự động',
      ocr: 'Chữ trên video',
      asr: 'Giọng nói',
    },
    modeShort: {
      auto: 'Tự động',
      ocr: 'Chữ',
      asr: 'Giọng nói',
    },
    modeHint: {
      auto: 'Đọc chữ trên video. Video không có chữ thì nghe giọng nói.',
      ocr: 'Chỉ đọc chữ hiện trên video (OCR).',
      asr: 'Chỉ nghe giọng nói trong video.',
      mixed: 'Mỗi video một cách, chọn ở danh sách bên dưới.',
    },
    runStatus: {
      running: 'Đang chạy',
      paused: 'Tạm dừng',
      pausedCredits: 'Hết credit',
      done: 'Hoàn tất',
      cancelled: 'Đã huỷ',
    },
    itemStatus: {
      queued: 'Chờ',
      fetching: 'Đang tải video',
      reading: 'Đang đọc chữ',
      listening: 'Đang nghe giọng nói',
      done: 'Xong',
      failed: 'Lỗi',
      cancelled: 'Đã huỷ',
    },
    translated: 'Phụ đề được dịch sang tiếng Việt.',
    notTranslated: 'Giữ nguyên ngôn ngữ gốc của phụ đề.',
    pause: 'Tạm dừng',
    resume: 'Tiếp tục',
    retryFailed_one: 'Chạy lại {{count}} video lỗi',
    retryFailed_other: 'Chạy lại {{count}} video lỗi',
    cancel: 'Huỷ phần còn lại',
    cancelTitle: 'Huỷ các video chưa xử lý?',
    cancelBody_one: '{{count}} video đang chờ sẽ không được xử lý. Các video đã xong và đang chạy vẫn giữ kết quả.',
    cancelBody_other: '{{count}} video đang chờ sẽ không được xử lý. Các video đã xong và đang chạy vẫn giữ kết quả.',
    creditsPaused:
      'Đã hết credit hôm nay nên đợt tạm dừng. Video đang chờ sẽ tiếp tục từ chỗ dừng (không tính tiền tải lại) khi bạn bấm Tiếp tục sau khi có credit.',
    stat: {
      done: 'Xong',
      working: 'Đang xử lý',
      waiting: 'Đang chờ',
      failed: 'Lỗi',
    },
    readerPc: 'Phụ đề đang được đọc trên máy tính của bạn (app VideoGrab), dùng hết sức máy.',
    readerServer:
      'Phụ đề đang được đọc trên máy chủ. Bạn có thể đóng trang này; hàng đợi vẫn tiếp tục chạy.',
    filter: 'Lọc video',
    filters: {
      all: 'Tất cả',
      active: 'Đang xử lý',
      done: 'Xong',
      failed: 'Lỗi',
    },
    nothingHere: 'Không có video nào ở mục này',
    video: 'Video',
    readFrom: 'Đọc phụ đề từ',
    result: 'Kết quả',
    lines_one: '{{count}} dòng phụ đề',
    lines_other: '{{count}} dòng phụ đề',
    kept_one: 'Giữ phụ đề có sẵn ({{count}} dòng)',
    kept_other: 'Giữ phụ đề có sẵn ({{count}} dòng)',
    noCaptions: 'Không tìm thấy phụ đề',
    addLinks: 'Thêm link vào đợt này',
    addHint: 'Link mới được nối vào cuối hàng đợi và xử lý tiếp ngay sau các video đang chờ.',
    addButton_one: 'Thêm vào đợt ({{count}})',
    addButton_other: 'Thêm vào đợt ({{count}})',
    addTitle_one: 'Thêm {{count}} video vào đợt',
    addTitle_other: 'Thêm {{count}} video vào đợt',
    addBody: 'Các video được nối vào cuối hàng đợi của đợt và đọc phụ đề theo cách bạn chọn.',
    addSubmit_one: 'Thêm vào hàng đợi ({{count}})',
    addSubmit_other: 'Thêm vào hàng đợi ({{count}})',
    added_one: 'Đã thêm {{count}} video vào hàng đợi',
    added_other: 'Đã thêm {{count}} video vào hàng đợi',
    addedNone: 'Các link này đã có trong đợt',
    target: 'Đưa link vào',
    targetAppend: 'Đợt đang chạy',
    targetNew: 'Một đợt mới',
    targetNewHint: 'Chạy sau các đợt đang có',
    manyLinks: 'Nhiều hơn 30 link? Dùng Xử lý hàng loạt',
  },

  detect: {
    action_one: 'Detect {{count}} video',
    action_other: 'Detect {{count}} video',
    button: 'Detect',
    detected: 'Đã detect',
    detecting: 'Đang detect',
    hasProject: 'Có dự án',
    lines_one: '{{count}} dòng',
    lines_other: '{{count}} dòng',
    openProject: 'Mở dự án',
    started_one: 'Đang detect {{count}} video. Theo dõi ngay tại đây hoặc trong Dự án.',
    started_other: 'Đang detect {{count}} video. Theo dõi ngay tại đây hoặc trong Dự án.',
    kept_one: 'Giữ nguyên {{count}} video đã detect trước đó (phụ đề không bị ghi đè).',
    kept_other: 'Giữ nguyên {{count}} video đã detect trước đó (phụ đề không bị ghi đè).',
    failed_one: '{{count}} video không detect được: {{reason}}',
    failed_other: '{{count}} video không detect được: {{reason}}',
    viewProjects: 'Xem trong Dự án',
    allKept: 'Các video này đã được detect. Mở chúng từ thẻ video.',
  },

  account: {
    title: 'Tài khoản',
    subtitle: 'Hồ sơ, bảo mật, thiết bị và credit của bạn.',
    profile: 'Hồ sơ & giao diện',
    security: 'Bảo mật',
    api: 'API',
    credits: 'Credit',
    displayName: 'Tên hiển thị',
    displayNameReadonly: 'Tên hiển thị do quản trị viên đặt.',
    language: 'Ngôn ngữ',
    theme: 'Giao diện',
    themeLight: 'Sáng',
    themeDark: 'Tối',
    themeSystem: 'Theo hệ thống',
    apiKeys: 'API key',
    apiKeysEmpty: 'Chưa có key nào',
    createKey: 'Tạo key mới',
    keyName: 'Tên gợi nhớ',
    keyCreatedTitle: 'Key mới đã được tạo',
    keyCreatedBody: 'Đây là lần duy nhất key được hiển thị đầy đủ. Hãy chép và cất giữ ngay.',
    revokeTitle: 'Thu hồi key?',
    revokeBody: 'Mọi ứng dụng đang dùng "{{name}}" sẽ ngừng hoạt động ngay lập tức.',
    keyLimit: 'Tối đa 10 key đang hoạt động.',
    apiDocs: 'Tài liệu API',
    apiDocsIntro: 'Xác thực bằng header Authorization: Bearer <key>.',
    apiScopeNote:
      'API key không dùng được cho các endpoint quản trị, tài khoản và quản lý key.',
    lastUsed: 'Dùng lần cuối',
    neverUsed: 'Chưa dùng',
    devicesTab: 'Máy của tôi',
    musicTab: 'Thư viện nhạc',
    securityPage: {
      intro: 'Đổi mật khẩu sẽ đăng xuất mọi phiên đăng nhập khác của bạn.',
      afterTitle: 'Sau khi đổi mật khẩu',
      afterSessions: 'Các trình duyệt và thiết bị khác phải đăng nhập lại bằng mật khẩu mới.',
      afterDevices: 'Máy tính đã cài VideoGrab tạm ngừng nhận việc, và tự kết nối lại khi bạn đăng nhập trên máy đó.',
    },
    music: {
      title: 'Thư viện nhạc',
      intro: 'Nhạc tải lên ở đây dùng được cho mọi dự án. Trong trình biên tập, bạn chỉ cần chọn bài.',
      upload: 'Tải nhạc lên',
      uploading: 'Đang tải lên {{percent}}%',
      formats: 'MP3, WAV, M4A, AAC hoặc OGG, tối đa {{max}} MB mỗi bài.',
      used: 'Đang có {{used}} / {{limit}} bài.',
      full: 'Thư viện đã đủ {{limit}} bài. Xoá bớt bài không dùng để tải thêm.',
      empty: 'Thư viện chưa có bài nào',
      emptyHint: 'Tải lên bài đầu tiên. Mỗi bài chỉ cần tải một lần, tối đa {{max}} MB.',
      play: 'Nghe thử',
      stop: 'Dừng nghe',
      remove: 'Xoá bài này',
      removeTitle: 'Xoá khỏi thư viện nhạc?',
      removeBody: '“{{name}}” sẽ biến mất khỏi mọi dự án đang dùng nó.',
      removeConfirm: 'Xoá khỏi thư viện',
      removed: 'Đã xoá khỏi thư viện',
      added: 'Đã thêm vào thư viện',
      alreadyInLibrary: 'Bài này đã có sẵn trong thư viện',
      playFailed: 'Không phát được bài này. Hãy thử lại.',
      backedUp: 'Mọi bài đã được sao lưu.',
      backupPending: '{{pending}} bài đang chờ sao lưu. Việc này tự chạy, bạn không cần làm gì.',
      backupWaiting: 'Chờ sao lưu',
    },
    devices: {
      title: 'Máy của tôi',
      intro: 'Máy tính đã cài VideoGrab có thể xử lý job được tạo trực tiếp trong ứng dụng desktop. Job từ trình duyệt luôn chạy trên máy chủ.',
      empty: 'Chưa có máy nào',
      emptyHint: 'Mở ứng dụng VideoGrab trên máy tính và đăng nhập. Máy sẽ tự xuất hiện ở đây.',
      online: 'Đang hoạt động',
      lastSeen: 'Hoạt động lần cuối {{when}}',
      neverConnected: 'Chưa kết nối lần nào',
      backendGpu: 'Đọc bằng card đồ hoạ',
      backendCpu: 'Đọc bằng CPU',
      readers_one: '{{count}} luồng đọc',
      readers_other: '{{count}} luồng đọc song song',
      speed: '{{fps}} khung hình mỗi giây',
      taskOcr: 'Đọc chữ trên video',
      taskAsr: 'Nhận giọng nói',
      tooSlow: 'Máy này đọc chậm hơn máy chủ, nên việc đọc chữ vẫn chạy trên máy chủ.',
      routingOff: 'Quản trị viên đang tắt xử lý trên máy người dùng. Mọi việc đang chạy trên máy chủ.',
      revoke: 'Gỡ máy này',
      revokeTitle: 'Gỡ máy này?',
      revokeBody: 'Máy "{{name}}" sẽ ngừng nhận việc ngay. Việc đang làm dở sẽ được máy chủ làm tiếp.',
      revoked: 'Đã gỡ máy',
    },
  },

  support: {
    title: 'Hỗ trợ',
    subtitle: 'Báo lỗi hoặc góp ý — chúng tôi đọc tất cả.',
    type: 'Loại yêu cầu',
    typeBug: 'Báo lỗi',
    typeUi: 'Góp ý giao diện',
    typeFeature: 'Đề xuất tính năng',
    typeOther: 'Khác',
    content: 'Nội dung',
    contentPlaceholder: 'Mô tả càng cụ thể càng tốt: bạn đang làm gì, chuyện gì xảy ra.',
    submit: 'Gửi yêu cầu',
    submitted: 'Đã gửi. Cảm ơn bạn!',
    myRequests: 'Yêu cầu của tôi',
    empty: 'Bạn chưa gửi yêu cầu nào',
    statusOpen: 'Đang xử lý',
    statusResolved: 'Đã xử lý',
  },

  admin: {
    users: 'Người dùng',
    invite: 'Mời người dùng',
    inviteEmail: 'Email',
    inviteName: 'Tên hiển thị',
    inviteLimit: 'Hạn mức credit/ngày',
    inviteLimitHint: 'Để trống để dùng mặc định của hệ thống.',
    inviteSent: 'Đã tạo tài khoản. Mật khẩu mặc định: {{password}}',
    role: 'Vai trò',
    lastLogin: 'Đăng nhập cuối',
    features: 'Tính năng',
    lock: 'Khoá',
    unlock: 'Mở khoá',
    lockTitle: 'Khoá tài khoản?',
    lockBody: '{{email}} sẽ bị đăng xuất khỏi mọi thiết bị và không đăng nhập được nữa.',
    unlockTitle: 'Mở khoá tài khoản?',
    unlockBody: '{{email}} sẽ đăng nhập lại được.',
    resetPassword: 'Đặt lại mật khẩu',
    resetTitle: 'Đặt lại mật khẩu?',
    resetBody:
      '{{email}} sẽ nhận mật khẩu mặc định và bị buộc đổi lại khi đăng nhập. Mọi phiên hiện tại bị huỷ.',
    setLimit: 'Đổi hạn mức',
    downloadHistory: 'Lịch sử tải',
    integrations: 'Tích hợp nền tảng',
    integrationsHint:
      'Cookie dùng để gọi API của nền tảng. Chỉ đọc — cấu hình trong .env, không sửa được ở đây.',
    cookieStatus: 'Trạng thái',
    cookieConfigured: 'Đã cấu hình',
    cookieMissing: 'Chưa có',
    cookieReadOnlyTitle: 'Cookie chỉ cấu hình trong .env',
    cookieReadOnlyBody:
      'Sửa biến tương ứng trong {{path}}, rồi khởi động lại máy chủ để áp dụng. Trang này chỉ hiển thị trạng thái; giá trị cookie không bao giờ rời khỏi máy chủ.',
    cookieEnvVar: 'Biến đang dùng',
    cookieMissingHint: 'Chưa đặt {{vars}} trong .env — các chức năng của nền tảng này sẽ lỗi.',
    cookieNames: 'Khoá trong cookie',
    cookieNamesMore_one: '+{{count}} khoá nữa',
    cookieNamesMore_other: '+{{count}} khoá nữa',
    cookieMissingCount_one: '{{count}} nền tảng chưa có cookie',
    cookieMissingCount_other: '{{count}} nền tảng chưa có cookie',
    feedbackInbox: 'Hộp thư góp ý',
    markResolved: 'Đánh dấu đã xử lý',
    reopen: 'Mở lại',
    noFeedback: 'Không có góp ý nào',
    feedbackEmailPlaceholder: 'Lọc theo email',
    roles: {
      admin: 'Quản trị',
      user: 'Người dùng',
    },
    userStatus: {
      active: 'Đang hoạt động',
      locked: 'Đã khoá',
      pending: 'Chờ kích hoạt',
      deactivated: 'Ngừng hoạt động',
    },
  },

  a11y: {
    mainNavigation: 'Điều hướng chính',
    userMenu: 'Menu tài khoản',
    jobTray: 'Khay công việc',
    creditBalance: 'Số dư credit',
    closeDialog: 'Đóng hộp thoại',
    loading: 'Đang tải nội dung',
    progress: 'Tiến độ {{percent}} phần trăm',
    progressIndeterminate: 'Đang xử lý, chưa rõ tiến độ',
  },
};

export type Dictionary = typeof vi;
